var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.htmlContent')
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-input', {
    staticClass: "html-content-editor",
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.optionModel.htmlContent),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "htmlContent", $$v)
      },
      expression: "optionModel.htmlContent"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbc9a59","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-html-text/htmlContent-editor.vue
// module id = null
// module chunks = 